export default __webpack_public_path__ + "static/Bm_EFTB_iMedical_Cont-31109627f806ddc3749a56841d6b15da.pdf";